import AjaxUtils from '../../util/ajax_utils';
import Vue from 'vue';
import { ApckTrustScanStatusColumn } from '../trust/trust_columns';

export const ApckAdminTrustReports = {
    data: function () {
        return {
            activeTab: 'all',
            search: '',
            appliedSearch: '',
            dateFrom: '',
            dateTo: '',
            pollTimer: null,

            counts: {
                total: 0,
                processed: 0,
                failed: 0,
                pending: 0,
                in_progress: 0,
                today_total: 0,
                today_processed: 0,
                today_failed: 0,
            },
            cols: [
                { data: 'organisation', heading: 'Organisation', width: 180 },
                { data: 'status', heading: 'Status', ctype: 'trust-scan-status', width: 110 },
                { data: 'upload_source', heading: 'Source', width: 90 },
                { data: 'uploaded_at', heading: 'Uploaded', ctype: 'datecolumn', width: 150 },
                { data: 'processing_completed_at', heading: 'Processed', ctype: 'datecolumn', width: 150 },
                { data: 'processing_duration', heading: 'Duration', width: 90 },
                { data: 'results_set_id', heading: 'Results Set', width: 180 },
                { data: 'processing_error', heading: 'Error' },
            ],
        }
    },
    computed: {
        statusParam: function () {
            return this.activeTab === 'all' ? '' : this.activeTab;
        },
        reportsSrc: function () {
            var params = [];
            if (this.statusParam) params.push('status=' + encodeURIComponent(this.statusParam));
            if (this.appliedSearch) params.push('search=' + encodeURIComponent(this.appliedSearch));
            if (this.dateFrom) params.push('date_from=' + encodeURIComponent(this.dateFrom));
            if (this.dateTo) params.push('date_to=' + encodeURIComponent(this.dateTo));
            return '/admin/trust_reports/list' + (params.length ? '?' + params.join('&') : '');
        },
        actions: function () {
            var cmp = this;
            return [
                {
                    icon: 'fa-rotate-right',
                    title: 'Retry',
                    class: 'btn-secondary',
                    handler: function (row) { cmp.retryReport(row.get('_id')); },
                    conditions: function (row) { return row.get('status') === 'failed'; },
                }
            ];
        },
        tabLabel: function () {
            return function (tab, count) {
                var labels = {
                    all: 'All',
                    processed: 'Processed',
                    failed: 'Failed',
                    pending: 'Pending',
                    in_progress: 'In Progress',
                };
                return (labels[tab] || tab) + ' (' + count + ')';
            };
        },
    },
    methods: {
        switchTab: function (tab) {
            this.activeTab = tab;
        },
        refresh: function () {
            this.fetchCounts();
            if (this.$refs.reportsTable) {
                this.$refs.reportsTable.store.load();
            }
        },
        fetchCounts: function () {
            var cmp = this;
            AjaxUtils.ajax_get({
                url: '/admin/trust_reports/counts',
                success: function (data) {
                    if (data && data.success) {
                        cmp.counts = {
                            total: data.total || 0,
                            processed: data.processed || 0,
                            failed: data.failed || 0,
                            pending: data.pending || 0,
                            in_progress: data.in_progress || 0,
                            today_total: data.today_total || 0,
                            today_processed: data.today_processed || 0,
                            today_failed: data.today_failed || 0,
                        };
                    }
                },
                fail: function () {},
                opts: {
                    dataType: 'json',
                    flash_form_errors: false,
                    show_success_flash: false,
                    flash_404_errors: false,
                }
            });
        },
        retryReport: function (reportId) {
            var cmp = this;
            AjaxUtils.ajax_post({
                url: '/admin/trust_reports/retry',
                data: JSON.stringify({ report_id: reportId }),
                success: function (data) {
                    if (data && data.success) {
                        cmp.refresh();
                    }
                },
                fail: function () {},
                opts: {
                    dataType: 'json',
                    contentType: 'application/json',
                    flash_form_errors: false,
                    show_success_flash: true,
                    flash_404_errors: false,
                }
            });
        },
        onSearchInput: function () {
            var cmp = this;
            if (cmp._searchTimer) clearTimeout(cmp._searchTimer);
            cmp._searchTimer = setTimeout(function () {
                cmp.appliedSearch = cmp.search;
            }, 400);
        },
    },
    created: function () {
        Vue.component('apck-trust-scan-status', ApckTrustScanStatusColumn);
    },
    mounted: function () {
        this.fetchCounts();
        var cmp = this;
        this.pollTimer = setInterval(function () {
            cmp.refresh();
        }, 30000);
    },
    beforeDestroy: function () {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    },
    template: `
        <ui-page title="Trust Reports" stickyTitle>
            <template #title-bar-buttons>
                <ui-button
                    label="Refresh"
                    iconLeft="fa-refresh"
                    type="outline"
                    @click.prevent="refresh"
                />
            </template>
            <template #content>
                <ui-layout direction="column" gap="0">
                    <div class="counter-row">
                        <div class="portlet">
                            <ui-panel-counter title="Total" :value="counts.total" color="light-slate" :loading="false" />
                        </div>
                        <div class="portlet">
                            <ui-panel-counter title="Processed" :value="counts.processed" color="green" :loading="false" />
                        </div>
                        <div class="portlet">
                            <ui-panel-counter title="Failed" :value="counts.failed" color="red" :loading="false" />
                        </div>
                        <div class="portlet">
                            <ui-panel-counter title="Pending" :value="counts.pending" color="orange" :loading="false" />
                        </div>
                        <div class="portlet">
                            <ui-panel-counter title="In Progress" :value="counts.in_progress" color="blue" :loading="false" />
                        </div>
                    </div>

                    <ui-layout direction="row" gap="0" align="end">
                        <ui-button
                            :label="tabLabel('all', counts.total)"
                            :type="activeTab === 'all' ? 'primary' : 'outline'"
                            tab
                            @click.prevent="switchTab('all')"
                        />
                        <ui-button
                            :label="tabLabel('processed', counts.processed)"
                            :type="activeTab === 'processed' ? 'primary' : 'outline'"
                            tab
                            @click.prevent="switchTab('processed')"
                        />
                        <ui-button
                            :label="tabLabel('failed', counts.failed)"
                            :type="activeTab === 'failed' ? 'primary' : 'outline'"
                            tab
                            @click.prevent="switchTab('failed')"
                        />
                        <ui-button
                            :label="tabLabel('pending', counts.pending)"
                            :type="activeTab === 'pending' ? 'primary' : 'outline'"
                            tab
                            @click.prevent="switchTab('pending')"
                        />
                        <ui-button
                            :label="tabLabel('in_progress', counts.in_progress)"
                            :type="activeTab === 'in_progress' ? 'primary' : 'outline'"
                            tab
                            @click.prevent="switchTab('in_progress')"
                        />
                    </ui-layout>

                    <ui-panel-base
                        direction="column"
                        justify="start"
                        align="stretch"
                        gap="2"
                        class="panel-box--tab-content"
                    >
                        <ui-layout class="filter-bar" align="center">
                            <ui-input-text
                                class="search-input"
                                placeholder="Search by organisation name..."
                                :modelValue="search"
                                @update:modelValue="search = $event; onSearchInput()"
                                iconLeft="fa-search"
                            />
                            <div class="date-filter-group">
                                <span class="date-filter-label">From</span>
                                <input
                                    type="date"
                                    class="date-filter-input"
                                    v-model="dateFrom"
                                />
                                <span class="date-filter-label">To</span>
                                <input
                                    type="date"
                                    class="date-filter-input"
                                    v-model="dateTo"
                                />
                            </div>
                        </ui-layout>

                        <apck-panel
                            title="Trust Monitor Report Uploads"
                            icon="fa-file-lines"
                            no-padding
                            class="trust-data-panel"
                        >
                            <apck-table
                                ref="reportsTable"
                                :key="activeTab"
                                :columns="cols"
                                :src="reportsSrc"
                                :actions="actions"
                                :limit="50"
                                :border="false"
                                :show-toolbar="false"
                                newStyleTable
                            />
                        </apck-panel>
                    </ui-panel-base>
                </ui-layout>
            </template>
        </ui-page>
    `
};
